import { ControlledTextField } from 'controlled-components';

type Props = {
  noLabel?: boolean;
} & Omit<React.ComponentProps<typeof ControlledTextField>, 'name' | 'label'>;

export function ControlledNameField({ noLabel = false, ...props }: Props): JSX.Element {
  return (
    <ControlledTextField
      name="name"
      label={noLabel ? '' : 'Vorname'}
      placeholder="John"
      required
      rules={{
        required: 'Dieses Feld ist erforderlich',
        pattern: { value: /^[a-zA-Z\u00C0-\u00ff\s'-]+$/, message: 'Dieser Name ist ungültig' },
        minLength: { value: 3, message: 'Dieser Name ist ungültig' },
      }}
      {...props}
    />
  );
}
